import "../../../datagrid.scss";
import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { Modal, Box } from "@mui/material";
import { ArticulosFormContext } from '../../../../context/articulos/ArticulosContext';
import { ArticulosCombosContext } from '../../../../context/articuloscombos/ArticulosCombosContext';
import { ArticulosCombosFormState } from '../../../../context/articuloscombos/ArticulosCombosFormState';
import { formatRows } from "./configGrid//rows";
import { indice } from "../../../../components/DataGrid/indice";
import { getActionColumn } from "../../../../components/DataGrid/actionColumns";
import FormCombo from './FormCombo/formCombo';
import useDocumentTitle from "../../../../components/Title";
import CustomDataGrid from "../../../../components/DataGrid/CustomDataGrid"
import ConfirmDialog from "../../../../components/dialogs/DeleteDialog";
import ErrorDialog from "../../../../components/dialogs/ErrorDeleteDialog";
import { fetchEntityData, deleteItem } from './configGrid/apiCalls';
import { Paginator } from '../../../../components/paginator/Paginator';
import { headers } from "./configGrid/headers";
import CircularProgress from "@mui/material/CircularProgress";

export const DatatableDetalle = ({ idCombo, dataCarac, addCarac, viewCarac, updateCarac, removeCarac }) => {
  const {
    getArticuloByIdData,
  } = useContext(ArticulosFormContext);
  const {
    getArticuloComboByIdData,
    deleteArticuloComboData
  } = useContext(ArticulosCombosContext);

  const [isModalComboOpen, setIsModalComboOpen] = useState(false);

  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalDataItems, setTotalDataItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(25);
  // Estado del buscador
  const [searchArtId, setSearchArtId] = useState();
  const [searchArtDesc, setSearchArtDesc] = useState();
  // Ref de input
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);
  // Estado para el modal de confirmación
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Estado para manejar el error
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  //EstadoForm
  const [estadoForm, setEstadoForm] = useState('');

  const nameData = "Articulo";
  const getData = getArticuloByIdData;
  const findData = getArticuloComboByIdData;
  const deleteData = deleteArticuloComboData;
  // Variables para arrayTemporal
  const tipo = 'combo';
  const arrayCombo = dataCarac[tipo] || [];
  const addItem = addCarac;
  const getItem = viewCarac;
  const updateItem = updateCarac;
  const removeItem = removeCarac;

  useEffect(() => {
    fetchData();
  }, [arrayCombo, idCombo,estadoForm]);

  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const { dataEntity, totalItems, totalPage,totalDataItems } = await fetchEntityData(
        getData,
        idCombo,
        numPagina,
        filas,
        setListaItems,
        setTotalItems,
        arrayCombo
      );

      if (numPagina > totalPage) {
        setNumPagina(totalPage);
      } else {
        setListaItems(dataEntity);
        setTotalItems(totalItems);
        setTotalDataItems(totalDataItems);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const handleClickEdit = async (id) => {
    try {
      setSelectedItem(id)

      // Abre el modal después de cargar los datos en selectedRow
      handleOpenModal();
    } catch (error) {
      console.error("Error al obtener detalles:", error);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteItem(deleteData, findData, selectedItem, arrayCombo, removeItem);
      fetchData(); // Refresca los datos
      closeModal(); // Cierra el modal de confirmación
    } catch (error) {
      console.error(error);
      setErrorMessage("No se pudo eliminar el elemento. Inténtalo nuevamente.");
      setIsErrorDialogOpen(true);
    }
  };

  const closeErrorDialog = () => {
    setErrorMessage(""); // Limpia el mensaje de error
    setIsErrorDialogOpen(false); // Cierra el diálogo de error
  };

  const openModal = (id) => {
    setSelectedItem(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
    fetchData();
  };

  const handleOpenModal = () => {
    setIsModalComboOpen(true);  // Función para abrir el modal
  };

  const handleCloseModal = () => {
    setIsModalComboOpen(false);  // Función para cerrar el modal
    setSelectedItem(null);   // Limpiamos la fila seleccionada
    fetchData()
  };

  // Dentro de la función Datatable...
  const datosColum = useMemo(() => {
    const commonCols = indice(numPagina, filas).concat(headers.filter((column) => !column.hidden)).concat(getActionColumn(handleClickEdit, openModal));
    return commonCols
  }, [numPagina, filas]);

  const rows = useMemo(() => formatRows(listaItems), [listaItems]);
 
  return (
    <>
      <div className="datatable">
        <div className="datatableTitle">
          Lista de los Articulos En Oferta
          {!idCombo &&
            <button
              type="button"
              className="link"
              onClick={handleOpenModal}
            >
              Agregar
            </button>
          }


        </div>
        {listaItems.length > 0 ? (
          <>
            <div className="datagridWrapper">
              <CustomDataGrid
                rows={rows.slice((numPagina - 1) * filas, numPagina * filas)}  // Filtrar según la página actual
                columns={datosColum}
                pageSize={filas}
                rowCount={totalItems}
                onPageChange={(newPage) => setNumPagina(newPage)}  // Actualizar página
                onPageSizeChange={(newPageSize) => {
                  setFilas(newPageSize);
                  setNumPagina(1);  // Resetear la página cuando se cambia el tamaño
                }}
                isLoading={isLoading}
              />
            </div>

            <div className="paginatorWrapper">
              <Paginator
                numPagina={numPagina}
                setNumPagina={setNumPagina}
                totalPages={Math.ceil(totalItems / filas)}  // Total de páginas
                filas={filas}
                setFilas={setFilas}
              />
            </div>

            <ConfirmDialog
              open={isModalOpen}
              onClose={closeModal}
              onConfirm={handleDelete}
              nameData={nameData}
            />

            <ErrorDialog
              open={isErrorDialogOpen}
              onClose={closeErrorDialog}
              errormessages={errorMessage}
            />
          </>
        ) : (
          <div className="noData">
            No existen artículos para este Articulo
          </div>
        )}

      </div>

      <ArticulosCombosFormState>
        <Modal
          open={isModalComboOpen}
          onClose={handleCloseModal}
          aria-labelledby="modal-form-detalle"
          aria-describedby="modal-form-detalle-descripcion"
          className="modalOferta"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: '80%', // Se ajusta para ser responsive
              maxHeight: '80%', // Limitar la altura
              width: '100%', // El ancho ocupará el 100% hasta el máximo
              height: 'auto', // Deja que la altura dependa del contenido
              bgcolor: 'background.paper',
              borderRadius: '8px',
              boxShadow: 24,
              p: 4,

              overflowY: 'auto', // Habilitar scroll vertical

            }}
          >
            <FormCombo
              idArt={selectedItem}
              arrayCombo={arrayCombo}
              estadoForm={estadoForm}
              setEstadoForm={setEstadoForm}
              addItem={addItem}
              updateItem={updateItem}
              getItem={getItem}
              removeItem={removeItem}
              closeModal={handleCloseModal}
            />

          </Box>
        </Modal>
      </ArticulosCombosFormState>
    </>
  );
};

export default DatatableDetalle;